import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import { useLoader } from "../context/LoaderContext";
import GlobalLoader from "../context/GlobalLoader";

const MasterLayout = ({ children }) => {
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation(); // Hook to get the current route
  const navigate = useNavigate();
  const { loading } = useLoader();

  // Token kontrolü - yoksa login'e yönlendir
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");

      // First, close all dropdowns
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px";
        }
      });

      // Then, find the dropdown that contains an active-page link
      allDropdowns.forEach((dropdown) => {
        const activeLink = dropdown.querySelector(".sidebar-submenu .active-page");
        if (activeLink) {
          dropdown.classList.add("open");
          const submenu = dropdown.querySelector(".sidebar-submenu");
          if (submenu) {
            submenu.style.maxHeight = `${submenu.scrollHeight}px`;
          }
        }
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    toast.success("Başarıyla çıkış yaptınız!");
    navigate("/login");
  };

  return (
    <>
      {loading && <GlobalLoader />}
      <section className={mobileMenu ? "overlay active" : "overlay "}>
        {/* sidebar */}
        <aside
          className={
            sidebarActive
              ? "sidebar active "
              : mobileMenu
                ? "sidebar sidebar-open"
                : "sidebar"
          }
        >
          <button
            onClick={mobileMenuControl}
            type='button'
            className='sidebar-close-btn'
          >
            <Icon icon='radix-icons:cross-2' />
          </button>
          <div>
            <Link to='/' className='sidebar-logo'>
              <img
                src='assets/images/logo.png'
                alt='site logo'
                className='light-logo'
              />
              <img
                src='assets/images/logo-light.png'
                alt='site logo'
                className='dark-logo'
              />
              <img
                src='assets/images/logo-icon.png'
                alt='site logo'
                className='logo-icon'
              />
            </Link>
          </div>
          <div className='sidebar-menu-area'>
            <ul className='sidebar-menu' id='sidebar-menu'>
              <li>
                <Link to='/dashboard'>
                  <Icon
                    icon='solar:home-smile-angle-outline'
                    className='menu-icon'
                  />
                  <span>Dashboard</span>
                </Link>
              </li>

              <li className='dropdown'>
                <Link to='#'>
                  <Icon icon='heroicons:puzzle-piece' className='menu-icon' />
                  <span>Oyunlar</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink to='/oyunlar'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <Icon
                        icon='flowbite:star-outline'
                        className='menu-icon'
                      />
                      <span>Oyunlar</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to='/sozluk'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <Icon
                        icon='heroicons:book-open'
                        className='menu-icon'
                      />
                      <span>Sözlük</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to='/puan-siralamasi'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <Icon
                        icon='heroicons:trophy'
                        className='menu-icon'
                      />
                      <span>Puan Sıralaması</span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink to='#'
                      className="d-flex align-items-center gap-2 opacity-75"
                      style={{ pointerEvents: 'none' }}>
                      <Icon
                        icon='heroicons:shield-check'
                        className='menu-icon'
                      />
                      <span>Oyun Verisi Yükle</span>
                      <span className="badge bg-warning text-white text-xs ms-auto radius-4">Yakında</span>
                    </NavLink>
                  </li>
                </ul>
              </li>

              <li className='dropdown'>
                <Link to='#'>
                  <Icon icon='heroicons:bell-alert' className='menu-icon' />
                  <span>Bildirim & Mail</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink to='/BildirimMailGonder'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <Icon
                        icon='heroicons:chat-bubble-bottom-center-text'
                        className='menu-icon'
                      />
                      <span>Bildirim ve Mail Gönder</span>
                    </NavLink>
                  </li>
                  <li>
                    <Link to='#'
                      className="d-flex align-items-center gap-2 opacity-75"
                      style={{ pointerEvents: 'none' }}
                    >
                      <Icon
                        icon='heroicons:inbox'
                        className='menu-icon'
                      />
                      <span>Bildirim ve Mail Geçmişi</span>
                      <span className="badge bg-warning text-white text-xs ms-auto radius-4">Yakında</span>
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to='/pazaryeri'>
                  <Icon
                    icon='heroicons:shopping-cart'
                    className='menu-icon'
                  />
                  <span>Pazaryeri</span>
                </Link>
              </li>

              <li className='dropdown'>
                <Link to='#'>
                  <Icon icon='heroicons:banknotes' className='menu-icon' />
                  <span>Ödemeler</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink to='/tum-odemeler'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <Icon
                        icon='heroicons:credit-card'
                        className='menu-icon'
                      />
                      <span>Tüm Ödemeler</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to='/iban-bilgileri'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <Icon
                        icon='heroicons:clipboard-document-list'
                        className='menu-icon'
                      />
                      <span>IBAN Bilgileri</span>
                    </NavLink>
                  </li>
                </ul>
              </li>

              <li className='dropdown'>
                <Link to='#'>
                  <Icon icon='heroicons:users' className='menu-icon' />
                  <span>Kullanıcılar</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink to='/kullanıcılar'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <Icon
                        icon='flowbite:users-group-outline'
                        className='menu-icon'
                      />
                      <span>Kullanıcılar</span>
                    </NavLink>
                  </li>
                </ul>
              </li>

              <li className='dropdown'>
                <Link to='#'>
                  <Icon icon='heroicons:cog-8-tooth' className='menu-icon' />
                  <span>Sistem Ayarları</span>
                </Link>
                <ul className='sidebar-submenu'>
                  <li>
                    <NavLink to='/SMTP'
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <Icon
                        icon='heroicons:at-symbol'
                        className='menu-icon'
                      />
                      <span>SMTP Ayarları</span>
                    </NavLink>
                  </li>
                </ul>
              </li>

              {/* LOGOUT */}
              <li className='sidebar-menu-group-title mt-32'> </li>
              <li>
                <button
                  onClick={handleLogout}
                  className='w-100 bg-danger text-white d-flex align-items-center justify-content-center gap-2 border-0 px-12 py-10 fw-semibold transition'
                  style={{ cursor: 'pointer', borderRadius: '8px' }}
                >
                  <Icon icon='lucide:power' className='text-xl' />
                  <span>Çıkış Yap</span>
                </button>
              </li>

            </ul>
          </div>
        </aside>

        <main
          className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
        >
          <div className='navbar-header'>
            <div className='row align-items-center justify-content-between'>
              <div className='col-auto'>
                <div className='d-flex flex-wrap align-items-center gap-4'>
                  <button
                    type='button'
                    className='sidebar-toggle'
                    onClick={sidebarControl}
                  >
                    {sidebarActive ? (
                      <Icon
                        icon='iconoir:arrow-right'
                        className='icon text-2xl non-active'
                      />
                    ) : (
                      <Icon
                        icon='heroicons:bars-3-solid'
                        className='icon text-2xl non-active '
                      />
                    )}
                  </button>
                  <button
                    onClick={mobileMenuControl}
                    type='button'
                    className='sidebar-mobile-toggle'
                  >
                    <Icon icon='heroicons:bars-3-solid' className='icon' />
                  </button>
                  <form className='navbar-search'>
                    <input type='text' name='search' placeholder='Ara..' />
                    <Icon icon='ion:search-outline' className='icon' />
                  </form>
                </div>
              </div>
              <div className='col-auto'>
                <div className='d-flex flex-wrap align-items-center gap-3'>
                  {/* ThemeToggleButton */}
                  <ThemeToggleButton />
                  <div className='dropdown'>
                    <button
                      className='d-flex justify-content-center align-items-center rounded-circle'
                      type='button'
                      data-bs-toggle='dropdown'
                    >
                      <img
                        src='assets/images/user.png'
                        alt='image_user'
                        className='w-40-px h-40-px object-fit-cover rounded-circle'
                      />
                    </button>
                  </div>
                  {/* Profile dropdown end */}
                </div>
              </div>
            </div>
          </div>

          {/* dashboard-main-body */}
          <div className='dashboard-main-body'>{children}</div>

          {/* Footer section */}
          <footer className='d-footer'>
            <div className='row align-items-center justify-content-between'>
              <div className='col-auto'>
                <p className='mb-0'>© 2024 Grep Teknoloji. All Rights Reserved.</p>
              </div>
              <div className='col-auto'>
                <p className='mb-0'>
                  Made by <span className='text-primary-600'>Grep Teknoloji</span>
                </p>
              </div>
            </div>
          </footer>
        </main>
      </section>
    </>
  );
};

export default MasterLayout;
